export function parseJsonIfPresent(value: string | undefined) {
    return value !== undefined && value !== '' ? JSON.parse(value) : undefined
  }